module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_2.de920c99.png";